/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { API_CONFIG, getApiUrl } from "@/config/apiConfig";
import { getAuthHeaders } from "./authApi";
import { handleResponse, handleListResponse } from "./apiHandler";

export const getTimewiseQRScanCounts = async (
  start_date?: string,
  end_date?: string,
  user_id?: string,
  project_id?: string,
) => {
  try {
    let endpoint =
      API_CONFIG.endpoints.analytics.timewiseScanCountsChart.replace(
        ":user_id",
        user_id,
      );
    let url = `${getApiUrl(endpoint)}?project_id=${project_id}`;

    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Timewise QR Scan Counts");
  } catch (error) {
    console.error("Error fetching QR list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getAnalyticsQRCardStats = async (
  start_date?: string,
  end_date?: string,
  user_id?: string,
  project_id?: string,
): Promise<any> => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.qrCardStats.replace(
      ":user_id",
      user_id,
    );
    let url = `${getApiUrl(endpoint)}?project_id=${project_id}`;

    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch QR Card Stats");
  } catch (error) {
    console.error("Error fetching QR Stats:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getDeviceQRScansPieChart = async (
  start_date?: string,
  end_date?: string,
  user_id?: string,
  project_id?: string,
): Promise<any> => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.deiveScansPieChart.replace(
      ":user_id",
      user_id,
    );
    let url = `${getApiUrl(endpoint)}?project_id=${project_id}`;

    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Device QR Scans");
  } catch (error) {
    console.error("Error fetching QR Stats:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getLocationScansDemographic = async (
  user_id: string,
  from_date?: string,
  to_date?: string,
): Promise<any> => {
  try {
    let endpoint =
      API_CONFIG.endpoints.analytics.locationScansDemographic.replace(
        ":user_id",
        user_id,
      );

    let url = getApiUrl(endpoint);

    if (from_date) url += `?from_date=${from_date}`;
    if (to_date) url += `${from_date ? "&" : "?"}to_date=${to_date}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Location Demographics");
  } catch (error) {
    console.error("Error fetching Location Demographics:", error);

    return {
      value: { topLocations: [], markers: [] },
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const devicewiseScansPieChartDeviceTab = async (
  start_date?: string,
  end_date?: string,
  user_id?: string,
  project_id?: string,
) => {
  let endpoint =
    API_CONFIG.endpoints.analytics.deviceWisePieChartDeviceTab.replace(
      ":user_id",
      user_id || "",
    );

  let url = getApiUrl(endpoint);

  const params = new URLSearchParams();
  if (start_date) params.append("start_date", start_date);
  if (end_date) params.append("end_date", end_date);
  if (project_id) params.append("project_id", project_id);

  url += `?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  return await handleResponse(response, "Fetch Device Wise Scans");
};

export const browserwiseScansPieChartDeviceTab = async (
  start_date?: string,
  end_date?: string,
  user_id?: string,
  project_id?: string,
) => {
  let endpoint =
    API_CONFIG.endpoints.analytics.browserPieChartDeviceTab.replace(
      ":user_id",
      user_id || "",
    );

  let url = getApiUrl(endpoint);

  const params = new URLSearchParams();
  if (start_date) params.append("start_date", start_date);
  if (end_date) params.append("end_date", end_date);
  if (project_id) params.append("project_id", project_id);

  url += `?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  return await handleResponse(response, "Fetch Browser Wise Scans");
};

export const browserAndOsGroupByScansTable = async (
  start_date?: string,
  end_date?: string,
  user_id?: string,
  project_id?: string,
) => {
  let endpoint =
    API_CONFIG.endpoints.analytics.deviceAndBrowserScansTable.replace(
      ":user_id",
      user_id || "",
    );

  let url = getApiUrl(endpoint);

  const params = new URLSearchParams();
  if (start_date) params.append("start_date", start_date);
  if (end_date) params.append("end_date", end_date);
  if (project_id) params.append("project_id", project_id);

  url += `?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  return await handleResponse(response, "Fetch Browser & OS Scans Table");
};

// new api

export const getAnalyticsCardStats = async (
  view_type?: string,
  user_id?: string,
  project_id?: string,
): Promise<any> => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.scanDetailsCard.replace(
      ":user_id",
      user_id,
    );
    let url = `${getApiUrl(endpoint)}?project_id=${project_id}&view_type=${view_type}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch QR Card Stats");
  } catch (error) {
    console.error("Error fetching QR Stats:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getTotalBarGraph = async (
  view_type: string,
  user_id?: string,
  project_id?: string,
): Promise<any> => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.barGraphCard.replace(
      ":user_id",
      user_id,
    );
    // let url = `${getApiUrl(endpoint)}?project_id=${project_id}`;
    const url = `${getApiUrl(endpoint)}?project_id=${project_id}&view_type=${view_type}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch QR Card Stats");
  } catch (error) {
    console.error("Error fetching QR Stats:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getTimewiseScanCounts = async (
  user_id?: string,
  project_id?: string,
) => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.scanLineChart.replace(
      ":user_id",
      user_id,
    );
    let url = `${getApiUrl(endpoint)}?project_id=${project_id}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Timewise QR Scan Counts");
  } catch (error) {
    console.error("Error fetching QR list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getinsights = async (
  user_id?: string,
  start_date?: string,
  end_date?: string,
) => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.insightsTable.replace(
      ":user_id",
      user_id,
    );
    let url = `${getApiUrl(endpoint)}?`;

    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Insights");
  } catch (error) {
    console.error("Error fetching QR list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};

export const getsourcemedium = async (
  user_id?: string,
  start_date?: string,
  end_date?: string,
) => {
  try {
    let endpoint = API_CONFIG.endpoints.analytics.sourcemedium.replace(
      ":user_id",
      user_id,
    );
    let url = `${getApiUrl(endpoint)}?`;

    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const response = await fetch(url, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    return await handleListResponse(response, "Fetch Insights");
  } catch (error) {
    console.error("Error fetching QR list:", error);

    return {
      value: [],
      status: 500,
      message: "Server error. Please try again later.",
    };
  }
};
